// Central config for all filter labels and backend mapping

export type FilterKey =
  | "toolsExperience"
  | "projectType"
  | "hardSkills"
  | "industry"
  | "offeredGratification"
  | "forGratification"
  | "projectDeadline"
  | "softSkills"
  | "requiredAvailability"
  | "offeredWorkingType"
  | "locations"
  | "usedLanguages"
  | "teamLocations"
  | "productType"
  | "productDescription";

export interface FilterConfig {
  label: string;         // Wyświetlana nazwa na froncie
  backendKey: string;    // Nazwa pola w bazie/backendzie
}

export const FILTERS: Record<FilterKey, FilterConfig> = {
  toolsExperience:      { label: "Tools",                backendKey: "tools_experience" },
  projectType:          { label: "Project Type",         backendKey: "project_type" },
  hardSkills:           { label: "Target Roles",         backendKey: "hard_skills" },
  industry:             { label: "Industry",             backendKey: "industry" },
  offeredGratification: { label: "Reward",               backendKey: "offered_gratification" },
  forGratification:     { label: "Compensation Basis",   backendKey: "for_gratification" },
  projectDeadline:      { label: "Collab Duration",   backendKey: "deadline" },
  softSkills:           { label: "Soft Skills",          backendKey: "soft_skills" },
  requiredAvailability: { label: "Hours per Week",  backendKey: "availability" },
  offeredWorkingType:   { label: "Working Type",         backendKey: "working_type" },
  locations:            { label: "Location",       backendKey: "locations" },
  usedLanguages:        { label: "Language",       backendKey: "used_languages" },
  teamLocations:        { label: "Location",       backendKey: "team_locations" },
  productType:          { label: "Product Type",         backendKey: "product_type" },
  productDescription:   { label: "Project Description",  backendKey: "project_description" },
}; 